/**
 * Molecule Component: TagFilterSection
 * Combines FilterChip atoms to create tag filtering UI
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '../StyledTypography';
import FilterChip from '../FilterChip/FilterChip';
import { useRequestTags } from '../../../hooks/features/requests/useRequestTags';
import { TAG_COLORS } from '../../../constants/request.constant';
import './TagFilterSection.css';

const TagFilterSection = ({
  tagOptions = [],
  selectedTags = [],
  onTagChange,
}) => {
  const { t } = useTranslation();
  const { getTagLabel } = useRequestTags();

  if (!tagOptions.length) return null;

  const handleTagToggle = (tag) => {
    const updated = selectedTags.includes(tag)
      ? selectedTags.filter((selected) => selected !== tag)
      : [...selectedTags, tag];

    onTagChange?.(updated);
  };

  return (
    <div className="tag-filter-section">
      <Typography variant="bodySmall" className="tag-filter-section__label">
        {t('Status Filter')}
      </Typography>

      <div className="tag-filter-section__chips">
        {tagOptions.map((tag) => (
          <FilterChip
            key={tag}
            label={getTagLabel(tag)}
            selected={selectedTags.includes(tag)}
            color={TAG_COLORS[tag]}
            onClick={() => handleTagToggle(tag)}
          />
        ))}
      </div>
    </div>
  );
};

export default TagFilterSection;
